// @file PWA related helpers
import { trackEvent } from '@@/bits/analytics'
import device from '@@/bits/device'

/**
 * Set up PWA installation tracking listener
 * @param app - App where installation occurred (e.g., 'Dashboard', 'Surface')
 * @param additionalProps - Additional properties to include in tracking
 */
function trackPWAInstallation(app: string, additionalProps: Record<string, any> = {}) {
  window.addEventListener('appinstalled', function () {
    // Determine OS
    let os = 'other'
    switch (true) {
      case device.ios:
        os = 'iOS'
        break
      case device.android:
        os = 'Android'
        break
      case device.mac:
        os = 'macOS'
        break
      case device.windows:
        os = 'Windows'
        break
      case device.windowsPhone:
        os = 'Windows Phone'
        break
      case device.windowsTouch:
        os = 'Windows Touch'
        break
      case device.webos:
        os = 'WebOS'
        break
      case device.blackberry:
        os = 'Blackberry'
        break
    }

    // Determine browser
    let browser = 'other'
    switch (true) {
      case device.chrome:
        browser = 'Chrome'
        break
      case device.firefox:
        browser = 'Firefox'
        break
      case device.safari:
        browser = 'Safari'
        break
      case device.edge:
        browser = 'Edge'
        break
      case device.ie || device.ie11 || device.ie10:
        browser = 'IE'
        break
      case device.webkit:
        browser = 'WebKit'
        break
    }

    // Determine platform type
    let platformType = 'other'
    switch (true) {
      case device.mobile:
        platformType = 'mobile'
        break
      case device.desktop:
        platformType = 'desktop'
        break
    }

    // Determine capabilities
    const capabilities = {
      // Push capabilities
      safariPush: device.safariPush,
      webPush: device.webPush,
      browserPush: device.browserPush,
      // Device capabilities
      touchable: device.touchable,
      mousable: device.mousable,
      retina: device.retina,
      clickGesture: device.clickGesture,
      dragFile: device.dragFile,
      cookies: device.cookies,
    }

    trackEvent('PWA', 'Installed', app, undefined, {
      os,
      browser,
      browserVersion: device.version,
      platformType,
      capabilities,
      userAgent: navigator.userAgent,
      ...additionalProps,
    })
  })
}

export { trackPWAInstallation }
